<div class="d-flex flex-column gap-2 h-100">
  <div class="review-entry-label">{{ label }}</div>
  <div class="review-entry-value mt-auto" [style.white-space]="'pre-wrap'">{{ value }}</div>
  <hr class="m-0" />
</div>
